var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_vm._v("测试页面 "),_c('div',{staticClass:"container",attrs:{"id":"container"}})])
}]

export { render, staticRenderFns }